import React, {FC} from 'react';
import styled from 'styled-components';

import {PaletteColorsEnum} from '../../../../../../libs/shared/core/src/models/api/paletteModel';
import {TooltipCoordinator} from '../../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {TooltipOverflowCondition} from '../../../../../../libs/shared/ui/src/components/tooltips/tooltipOverflowCondition';
import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface CellTagColorProps {
  name: string;
  color: PaletteColorsEnum;
}

/*
 * Style.
 */

interface TagStyleProps {
  $color: PaletteColorsEnum;
}
const StyledTagDiv = styled(TooltipCoordinator)<TagStyleProps>`
  padding: 1px 3px;
  border-radius: 2px;
  background-color: ${(p) => p.theme.tag.findBackgroundColor(p.theme, p.$color)};
  border: 1px solid ${(p) => p.theme.tag.findBorderColor(p.theme, p.$color)};

  color: ${(p) => p.theme.tag.findColor(p.theme, p.$color)};
  overflow: hidden;
`;

const StyledName = styled(TooltipOverflowCondition)`
  line-height: 12px;
  font-size: ${fontSizes.veryTiny};
  font-weight: ${fontWeights.semibold};
  text-transform: uppercase;

  ${ellipsis()};
`;

/*
 * Component.
 */

export const CellTagColor: FC<CellTagColorProps> = (props) => (
  <StyledTagDiv $color={props.color} render={() => props.name}>
    <StyledName>{props.name}</StyledName>
  </StyledTagDiv>
);
